import React from "react"
import { Row, Col, Container } from 'react-bootstrap'
import { injectIntl } from "gatsby-plugin-react-intl"
import IntroData from "../../content/home/intro.json"

class Intro extends React.Component {
    render = () => {
        return (
            <div className={`home-intro`}>
                <Container>
                    <Row>
                        <Col md={5}>
                            <div className={`title`}>
                                <div className={`lines`}>
                                    <div className={`line-up`}></div>
                                    <div className={`line-down`}></div>
                                </div>
                                {IntroData[this.props.intl.locale].title}
                            </div>
                        </Col>
                        <Col md={7}>
                            <div className={`text`} dangerouslySetInnerHTML={{ __html: IntroData[this.props.intl.locale].text}}></div>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}

export default injectIntl(Intro)
